module.exports = __webpack_public_path__ + "media/images/menu/aquarius-47302cd0338616b23cf1d8bffdc44646.jpg";